export const MASKED_PRICE = '*******';

export const isMaskedValue = (value: unknown): boolean => value === MASKED_PRICE;

export const isMaskedPrice = isMaskedValue;
